import styled from "styled-components";
import globalStyles from "../../../constants/globalStyles/theme.json";

const { colors } = globalStyles;

export const Button = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;

  &:focus {
    outline: none;
  }
`;

export const Line = styled.div<{ $isOpen?: boolean }>`
  width: 100%;
  height: 3px;
  background: ${({ $isOpen }) => ($isOpen ? colors.primary.offWhite : colors.primary.black)};
  transition: all 0.3s ease;
`;
